export default __webpack_public_path__ + "static/media/KZ.T.09.0592 black.a021c73d.svg";